import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { 
  FiArrowRight, FiHeart, FiMail, FiPhone, FiGlobe, FiMenu, 
  FiX, FiChevronUp, FiHome, FiAlertCircle, FiSearch
} from 'react-icons/fi';
import { FaWhatsapp, FaFacebook, FaInstagram } from 'react-icons/fa';
import { GiCoffeeCup } from 'react-icons/gi';
import logo from '../Assets/logometropole.png';

const Oops = () => {
  const [showMobileMenu, setShowMobileMenu] = useState(false);
  const [showScrollButton, setShowScrollButton] = useState(false);

  // Gestion du scroll pour le bouton
  useEffect(() => {
    const handleScroll = () => {
      setShowScrollButton(window.scrollY > 300);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Fonction pour remonter en haut
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  // Fonction pour réserver (appel téléphonique)
  const handleReservation = () => {
    window.location.href = 'tel:+212522820267';
  };

  return (
    <div className="min-h-screen bg-white flex flex-col">
      {/* Header - Style marron et blanc */}
      <header className="bg-white shadow-md sticky top-0 z-50 border-b border-[#D4A574]">
        <div className="container mx-auto px-4 py-3">
          <div className="flex justify-between items-center">
            <Link to="/" className="flex items-center group">
              <img 
                src={logo} 
                alt="Espace Métropole" 
                className="h-12 w-auto object-contain"
              />
            </Link>

            {/* Desktop Navigation */}
            <nav className="hidden md:flex items-center space-x-6">
              <Link to="/" className="text-[#5C4033] hover:text-[#1B5E20] font-medium text-sm uppercase tracking-wider transition-colors">
                Accueil
              </Link>
              <Link to="/carte" className="text-[#5C4033] hover:text-[#1B5E20] font-medium text-sm uppercase tracking-wider transition-colors">
                Notre Menu
              </Link>
              <a href="/#offres" className="text-[#5C4033] hover:text-[#1B5E20] font-medium text-sm uppercase tracking-wider transition-colors">
                Offres
              </a>
              <button 
                onClick={handleReservation}
                className="bg-[#5C4033] text-white px-5 py-2 rounded-full hover:bg-[#1B5E20] transition-all text-sm uppercase tracking-wider font-semibold flex items-center gap-2 shadow-md"
              >
                <FiHeart className="text-sm" />
                Réserver
              </button>
            </nav>

            {/* Mobile Menu Button */}
            <button 
              onClick={() => setShowMobileMenu(!showMobileMenu)}
              className="md:hidden p-2 rounded-lg hover:bg-[#F5E6D3]"
            >
              {showMobileMenu ? <FiX className="text-2xl text-[#5C4033]" /> : <FiMenu className="text-2xl text-[#5C4033]" />}
            </button>
          </div>

          {/* Mobile Navigation */}
          <div className={`md:hidden transition-all duration-300 overflow-hidden ${
            showMobileMenu ? 'max-h-96 opacity-100 mt-3' : 'max-h-0 opacity-0'
          }`}>
            <div className="flex flex-col space-y-2 pb-3">
              <Link to="/" className="text-[#5C4033] hover:text-[#1B5E20] py-2" onClick={() => setShowMobileMenu(false)}>
                Accueil
              </Link>
              <Link to="/carte" className="text-[#5C4033] hover:text-[#1B5E20] py-2" onClick={() => setShowMobileMenu(false)}>
                Notre Menu
              </Link>
              <a href="/#offres" className="text-[#5C4033] hover:text-[#1B5E20] py-2" onClick={() => setShowMobileMenu(false)}>
                Offres
              </a>
              <button 
                onClick={() => {
                  handleReservation();
                  setShowMobileMenu(false);
                }}
                className="bg-[#5C4033] text-white px-5 py-2 rounded-full font-semibold flex items-center justify-center gap-2 text-sm"
              >
                <FiHeart />
                Réserver
              </button>
            </div>
          </div>
        </div>
      </header>

      {/* Main Content - 404 Error */}
      <main className="flex-grow flex items-center justify-center px-4 py-16 md:py-24">
        <div className="container mx-auto max-w-3xl">
          <div className="text-center">
            {/* Icône 404 animée */}
            <div className="relative inline-block mb-6">
              <div className="absolute inset-0 bg-[#1B5E20]/10 rounded-full blur-2xl"></div>
              <div className="relative bg-[#F5E6D3] rounded-full p-6 md:p-8 inline-block border border-[#D4A574] animate-bounce">
                <GiCoffeeCup className="text-5xl md:text-7xl text-[#5C4033]" />
              </div>
            </div>

            {/* Code d'erreur */}
            <div className="mb-6">
              <span className="text-[#1B5E20] text-sm uppercase tracking-wider font-semibold bg-[#F5E6D3] px-4 py-1.5 rounded-full">
                Erreur 404
              </span>
            </div>

            <h1 className="text-6xl md:text-8xl font-bold text-[#5C4033] mb-4">
              Oops !
            </h1>

            <h2 className="text-2xl md:text-3xl font-semibold text-[#5C4033] mb-4">
              Page non trouvée
            </h2>

            <div className="w-16 h-0.5 bg-[#1B5E20] mx-auto mb-6"></div>

            <p className="text-[#8B6914] text-base md:text-lg mb-8 max-w-md mx-auto">
              Désolé, la page que vous recherchez n'existe pas ou a été déplacée.
            </p>

            {/* Suggestions */}
            <div className="bg-[#F9F6F0] rounded-xl p-6 mb-8 max-w-md mx-auto border border-[#F5E6D3]">
              <p className="text-[#5C4033] font-semibold mb-3 flex items-center justify-center gap-2">
                <FiAlertCircle className="text-[#1B5E20]" />
                Vous pourriez essayer :
              </p>
              <div className="flex flex-col sm:flex-row gap-3 justify-center">
                <Link 
                  to="/"
                  className="inline-flex items-center justify-center gap-2 bg-[#5C4033] text-white px-5 py-2.5 rounded-full hover:bg-[#1B5E20] transition-all text-sm font-medium"
                >
                  <FiHome />
                  Accueil
                </Link>
                <Link 
                  to="/carte"
                  className="inline-flex items-center justify-center gap-2 border border-[#5C4033] text-[#5C4033] px-5 py-2.5 rounded-full hover:bg-[#F5E6D3] hover:border-[#1B5E20] transition-all text-sm font-medium"
                >
                  <FiSearch />
                  Voir la carte
                </Link>
              </div>
            </div>

            {/* Bouton Réserver */}
            <button 
              onClick={handleReservation}
              className="inline-flex items-center gap-2 bg-white border-2 border-[#5C4033] text-[#5C4033] px-6 py-3 rounded-full text-base font-semibold hover:bg-[#5C4033] hover:text-white transition-all shadow-md group"
            >
              <FiHeart />
              Réserver une table
              <FiArrowRight className="group-hover:translate-x-1 transition-transform" />
            </button>
          </div>
        </div>
      </main>

      {/* Footer - Marron et Vert Foncé */}
      <footer className="bg-[#5C4033] text-white py-10 mt-auto">
        <div className="container mx-auto px-4">
          <div className="grid md:grid-cols-3 gap-8">
            <div className="text-center md:text-left">
              <div className="flex items-center justify-center md:justify-start mb-3">
                <div className="bg-white rounded-lg p-1.5 shadow-lg">
                  <img src={logo} alt="Logo" className="h-8 w-auto object-contain" />
                </div>
              </div>
              <p className="text-[#D4C4A8] text-sm">
                L'élégance au cœur de Casablanca
              </p>
            </div>
     
            <div className="text-center">
              <h4 className="text-base font-semibold mb-3 text-[#A5D6A7]">Contact</h4>
              <ul className="space-y-2 text-sm">
                <li className="flex items-center justify-center gap-2 text-[#D4C4A8]">
                  <FiPhone className="text-[#A5D6A7] text-xs" />
                  <span>(+212) 522-820-267</span>
                </li>
                <li className="flex items-center justify-center gap-2 text-[#D4C4A8] text-xs">
                  <FiMail className="text-[#A5D6A7]" />
                  <span>contact@espace-metropole.ma</span>
                </li>
                <li className="flex items-center justify-center gap-2 text-[#D4C4A8] text-xs">
                  <FiGlobe className="text-[#A5D6A7]" />
                  <span>www.espace-metropole.ma</span>
                </li>
              </ul>
            </div>
            
            <div className="text-center md:text-right">
              <h4 className="text-base font-semibold mb-3 text-[#A5D6A7]">Suivez-nous</h4>
              <div className="flex justify-center md:justify-end space-x-3">
                <a href="#" className="w-8 h-8 bg-[#7A5C48] rounded-full flex items-center justify-center hover:bg-[#1B5E20] transition-all">
                  <FaFacebook className="text-sm" />
                </a>
                <a href="#" className="w-8 h-8 bg-[#7A5C48] rounded-full flex items-center justify-center hover:bg-[#1B5E20] transition-all">
                  <FaInstagram className="text-sm" />
                </a>
                <a href="#" className="w-8 h-8 bg-[#7A5C48] rounded-full flex items-center justify-center hover:bg-[#1B5E20] transition-all">
                  <FaWhatsapp className="text-sm" />
                </a>
              </div>
            </div>
          </div>
          
          <div className="border-t border-[#7A5C48] mt-8 pt-6 text-center text-[#C4A77D] text-xs">
            <p>&copy; 2026 Espace Métropole. Tous droits réservés.</p>
          </div>
        </div>
      </footer>

      {/* Bouton Scroll to Top */}
      <button
        onClick={scrollToTop}
        className={`fixed bottom-6 right-4 md:hidden bg-[#1B5E20] text-white p-3 rounded-full shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-110 z-40 ${
          showScrollButton ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10 pointer-events-none'
        }`}
        aria-label="Retour en haut"
      >
        <FiChevronUp className="text-xl" />
      </button>
    </div>
  );
};

export default Oops;